var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m62.69 20.637-9.25 6.912 4.387 1.883-9.54 22.228-9.074-21.821a1 1 0 0 0-1.852.012l-6.48 16.201-8.784-6.77a1 1 0 0 0-1.59.589l-3.608 17.41a1 1 0 1 0 1.958.407l3.284-15.847 8.566 6.603a1 1 0 0 0 1.54-.42l6.06-15.154 9.042 21.743a1 1 0 0 0 1.842.01l10.474-24.402 4.387 1.882z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M72.284 17.637a4 4 0 0 0-4-4h-56a4 4 0 0 0-4 4v42.848a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4zm-62 0a2 2 0 0 1 2-2h56a2 2 0 0 1 2 2v42.848a2 2 0 0 1-2 2h-56a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
};
export default SvgDashboard;